<h3>Proč potřebujeme Songmaster?</h3>
SongMaster ti pomůže při učení a procvičování písní. Pamatuje si co umíš, co se učíš a co se naučit chceš.
U každé písně se ví jak dlouho jsi ji nehrál(a), v jaké tónině a tempu ji hraješ a mnoho dalšího.

<h3>Jak to funguje?</h3>
Předpokladem je, že nějaké písně se učíš, nějaké už umíš, nějaké se naučit chceš v budoucnu.
Tlačítky nahoře si volíš, ze kterého seznamu chceš zrovna hrát.
Apka ti vybere takovou, která to nejvíc potřebuje - buď proto, že se dlouho nehrála, nebo že měla špatné hodnocení

<h3>Jak nejlépe postupovat?</h3>
Ještě než si písničku zahraješ poprvé, tak si zvol tempo, vyber tóninu, můžeš si přidat odkazy na stránky s textem,
video apod.
To ti pomůže příště při dalším cvičení. Dole jsou odkazy na běžné weby s texty a akordy.
<br>
Když je po všem, tak si píseň ohodnoť. Když ohodnotíš písničku z fronty nebo ze zapomenutých, tak se přesune do učení.
Tlačítky kolem hvězdiček píseň přesuneš do hotových apod. Prostě sleduj popisky.

<h3>Jak je to s těmi seznamy?</h3>
Každá píseň může být v jednom ze čtyř stavů (seznamů):
<ul>
	<li><strong>učení</strong>: píseň co se právě učíš, chceš si ji často procvičovat</li>
	<li><strong>hotové</strong>: písně co už si několikrát zasloužily 5 hvězdiček můžeš tlačítkem přesunout do hotových.
		Je dobré si každý den ťuknout na opakování a nějakou si oživit.</li>
	<li><strong>fronta</strong>: tyto čekají, až se na ně dostane řada. Jakmile si takovou písničku ohodnotíš, přesune
		se do učení. Nebo ji tlačítkem "už to umím" přesuň rovnou do hotových.</li>
	<li><strong>zapomenuté</strong>: to se snad nikdy nestane :-)</li>
</ul>

<h3>Co když se mi všechno ztratilo?</h3>
Data o písničkách se ukládají v prohlížeči na počítači a na serveru pod generovaným kódem.
Pokud data zmizla a nemáš kód, kontaktuj mě.

<h3>Nakonec</h3>
Ano, potřebovalo by to ostylovat, pokud to umíš tak ocením pomoc. Budu rád za každý podnět k vylepšení, na apce stále
pracuju, takže se může snadno stát, že tvůj návrh bude realizován!

<h3>Kontakt:</h3>
<a href="mailto:ondrej.preclik@gmail.com?subject=songmaster">ondrej.preclik@gmail.com</a>
